<template>
	<main class="vx-row">
		<div class="vx-col w-full">
			<vx-card>
				<div v-if="zakatCaption !== null" class="mt-4 mb-6">
					<h3 class="text-success"><strong>{{ zakatCaption }}</strong></h3>
				</div>

				<form>
					<span class="text-danger text-sm my-6" v-show="errors.has('deposito')">{{ errors.first('deposito') }}</span>
					<p class="mb-2"><strong>Nilai Deposito/Tabungan/Giro</strong></p>
					<vs-input
					    v-model="deposito"
					    @keyup="toRupiahDeposito()"
					    class="w-full mb-6"
					    size="large"
					    v-validate="'required'"
					    dir="rtl"
					    name="deposito"
					/>

					<span class="text-danger text-sm my-6" v-show="errors.has('properti')">{{ errors.first('properti') }}</span>
					<p class="mb-2"><strong>Nilai Properti/Kendaraan</strong></p>
					<vs-input
					    v-model="properti"
					    @keyup="toRupiahProperti()"
					    class="w-full mb-6"
					    size="large"
					    v-validate="'required'"
					    dir="rtl"
					    name="properti"
					/>

					<span class="text-danger text-sm my-6" v-show="errors.has('debt')">{{ errors.first('debt') }}</span>
					<p class="mb-2"><strong>Hutang Pribadi Yang Jatuh Tempo Tahun Ini</strong></p>
					<vs-input
					    v-model="debt"
					    @keyup="toRupiahDebt()"
					    class="w-full mb-6"
					    size="large"
					    v-validate="'required'"
					    dir="rtl"
					    name="debt"
					/>

					<span class="text-danger text-sm my-6" v-show="errors.has('gold')">{{ errors.first('gold') }}</span>
					<p class="mb-2"><strong>Emas, Perak, Permata, atau sejenisnya</strong></p>
					<vs-input
					    v-model="gold"
					    @keyup="toRupiahGold()"
					    class="w-full mb-6"
					    size="large"
					    v-validate="'required'"
					    dir="rtl"
					    name="gold"
					/>
					
					<span class="text-danger text-sm my-6" v-show="errors.has('other')">{{ errors.first('other') }}</span>
					<p class="mb-2"><strong>Lainnya</strong></p>
					<vs-input
					    v-model="other"
					    @keyup="toRupiahOther()"
					    class="w-full mb-6"
					    size="large"
					    v-validate="'required'"
					    dir="rtl"
					    name="other"
					/>
					<br>
					<vs-button
					    color="primary"
					    size="large"
					    class="w-full mb-4"
					    @click.prevent="calculateZakat"
					>
					Hitung Zakat
					</vs-button>
					<vs-button
					    color="warning"
					    size="large"
					    type="gradient"
					    class="w-full mb-4"
					    @click.prevent="payZakat"
					>
					<span class="text-dark">Bayar {{ capitalize(type) }}</span>
					</vs-button>	
				</form>
			</vx-card>
		</div>
	</main>
</template>
<script>
import { Validator } from 'vee-validate'
import { minNishabZakat, goldPrice } from '@/assets/utils/zakat'

const dict = {
  custom: {
    deposito: {
      required: 'Harap masukan jumlah tabungan anda'
    },
    properti: {
      required: 'Harap masukan nilai properti anda'	
    },
    debt: {
      required: 'Harap masukan hutang anda'	
    },
    gold: {
      required: 'Harap masukan nilai emas/perak/permata anda'	
    },
    other: {
      required: 'Harap masukan jumlah harta anda yang lain'
    }
  }
}

Validator.localize('en', dict)

export default {
  data: () => ({
    type: 'zakat',
    zakatCaption: null,
    zakat: 0,
    other: 0,
    gold: 0,
    debt: 0,
    properti: 0,
    deposito: 0
  }),
  methods: {
    toRupiahDeposito () {
      this.deposito = this.formatRupiah(this.deposito)
    },
    toRupiahOther () {
      this.other = this.formatRupiah(this.other)
    },
    toRupiahGold () {
      this.gold = this.formatRupiah(this.gold)
    },
    toRupiahDebt () {
      this.debt = this.formatRupiah(this.debt)
    },
    toRupiahProperti () {
      this.properti = this.formatRupiah(this.properti)
    },
    calculateZakat () {
      this.$validator.validateAll().then(res => {
        if (res) {
          const gold = parseInt(this.gold.toString().replace(/[^0-9-,]/g, '')),
            deposito = parseInt(this.deposito.toString().replace(/[^0-9-,]/g, '')),
            properti = parseInt(this.properti.toString().replace(/[^0-9-,]/g, '')),
            debt = parseInt(this.debt.toString().replace(/[^0-9-,]/g, '')),
            other = parseInt(this.other.toString().replace(/[^0-9-,]/g, '')),
            myGoldPrice = 85 * goldPrice,
            result = parseInt((gold + deposito + properti + other) - debt),
            finalResult = Math.ceil(minNishabZakat * result)

          if (result < myGoldPrice) {
            this.zakat = finalResult
            this.zakatCaption = 'Anda belum wajib mengeluarkan zakat maal'
            this.type = 'infaq'
							
          } else {
            this.zakat = finalResult
            this.type = 'zakat'

            this.zakatCaption = `Hasil perhitungan zakat anda Rp ${ this.formatRupiah(finalResult) }`
          }
        }
      })

    },
    payZakat () {
      this.$emit('payZakat', {total: this.zakat, type: this.type})
    }
  }
}
</script>